/* eslint-disable jsx-a11y/anchor-is-valid */

import styled from "@emotion/styled"

const NavigationContainer = styled.nav`
    &&& {
        display: flex;
        width: 25%;
        justify-content: space-between;
    }
`

const FancyLink = styled.a`
    &&& { 
        color: black;
        position: relative;
        font-weight: bold;
        text-decoration: none;
    }

    &&&:hover {
        text-decoration: underline;
    }
`


const Navigation: React.FC = () => {

    return (
        <NavigationContainer>
            <FancyLink href="/about">
                About
            </FancyLink>
            <FancyLink href="/things">
                Things
            </FancyLink>
            <FancyLink href="/how">
                How
            </FancyLink>
        </NavigationContainer>
    )
}

export default Navigation